// Lib
import { ThemeFile } from 'lib/context/ThemeContext';

export const RecentlyViewedDocumentsTheme: ThemeFile = {
  aw: {
    classes: {
      headlineBorder: 'col-span-12 border-t-2 border-black md:col-span-3',
      headlineClass: 'text-text-link lg:text-xs font-heavy uppercase mr-1',
    },
  },
  rba: {
    classes: {},
  },
};
